module.exports = "<div class=\"ubg-layout\" [ngClass]=\"cssClass\">\n  <ng-content></ng-content>\n</div>"